import { render, staticRenderFns } from "./PItemRow2-ISO.vue?vue&type=template&id=6f1feafc"
import script from "./PItemRow2-ISO.vue?vue&type=script&lang=js"
export * from "./PItemRow2-ISO.vue?vue&type=script&lang=js"
import style0 from "./PItemRow2-ISO.vue?vue&type=style&index=0&id=6f1feafc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports